import { RootState } from "redux/rootReducer";

export const selectIsVerifyPhoneNumber = (state: RootState) =>
  state.verifyPhoneNumber.loading;
export const selectVerifyPhoneNumberErrorMessage = (state: RootState) =>
  state.verifyPhoneNumber.error;
export const verifyPhoneNumberDataResponse = (state: RootState) =>
  state.verifyPhoneNumber.verifyPhoneNumberResponse;
